import { Typography } from '@lightbeamai/design-system'
import React from 'react'
import { useIntl } from 'react-intl'

export const DetectionInstructions = ({
  transIdKey
}: {
  transIdKey: 'detectionKeys' | 'patterns' | 'basic'
}) => {
  const intl = useIntl()
  return (
    <>
      <Typography type="medium">
        {intl.formatMessage({
          id: `attributeManagementSettings.customAttributes.detection.keyValue.${transIdKey}`
        })}
      </Typography>
      <Typography>
        {intl.formatMessage({
          id: `attributeManagementSettings.customAttributes.detection.keyValue.${transIdKey}.description_1`
        })}
      </Typography>
      <Typography>
        {intl.formatMessage({
          id: `attributeManagementSettings.customAttributes.detection.keyValue.${transIdKey}.description_2`
        })}
      </Typography>

      <ul className="detection-instructions-list">
        <Typography as="li">
          {intl.formatMessage({
            id: `attributeManagementSettings.customAttributes.detection.keyValue.${transIdKey}.description_3`
          })}
        </Typography>

        <Typography as="li">
          {intl.formatMessage({
            id: `attributeManagementSettings.customAttributes.detection.keyValue.${transIdKey}.description_4`
          })}
        </Typography>
      </ul>
    </>
  )
}
